import queryString from "query-string";
import {
  GetDate,
  GetIdsList,
  GetImprestStateList,
  GetMainType,
  GetSortField,
  GetSortType,
  GetTextSearch
} from "../../../../../assets/convertUrlFilter";
import { OVERALL_COST } from "../../../../../constants/sectionTypes";
import {
  ALL_IMPREST_STATES_ARRAY,
  END_DATE,
  FILE_TYPE,
  IMPREST_IDS,
  IMPREST_STATES,
  IMPREST_STATES_FOR_OTHER_REPORTS,
  ROUTES,
  SORT_FIELD,
  SORT_TYPE,
  START_DATE,
  TEAM_IDS,
  TEXT_SEARCH,
  TYPE,
  USE_DETAIL,
  USER_IDS
} from "../../../../../constants/filters";
import { FILE_TYPES } from "../../../../../constants/file";

// const defaultFilter = {
//   file_type: "web",
//   type: 1,
//   sort_field: "amount",
//   sort_type: "desc",
//   routes: [],
//   text_search: "",
//   tab: 0,
//   page_number: "",
//   use_detail:false,
//   creator_user_ids:[]
// };

export default () => {
  let filters = queryString.parse(document.location.search);
  return filtersNormalize(filters);
};

const filtersNormalize = filters => {
  const type =
    filters[TYPE] && filters[TYPE] <= 4 && filters[TYPE] >= 1
      ? filters[TYPE]
      : 0;
  return {
    [FILE_TYPE]: FILE_TYPES.WEB,
    [TYPE]: GetMainType(type),
    [IMPREST_IDS]: GetIdsList(filters[IMPREST_IDS]),
    [START_DATE]: GetDate(filters[START_DATE]),
    [END_DATE]: GetDate(filters[END_DATE]),
    [ROUTES]: filters[ROUTES]
      ? filters[ROUTES].split("~").map(item => {
          let par = item.split(".");
          let id = par[0];
          let type = par[1];
          return { id, type };
        })
      : [],
    [SORT_FIELD]: GetSortField(filters[SORT_FIELD], OVERALL_COST),
    [SORT_TYPE]: GetSortType(filters[SORT_TYPE], OVERALL_COST),
    [TEXT_SEARCH]: GetTextSearch(filters[TEXT_SEARCH]),
    [USE_DETAIL]: false,
    [USER_IDS]: GetIdsList(filters[USER_IDS]),
    [TEAM_IDS]: GetIdsList(filters[TEAM_IDS]),
    [IMPREST_STATES_FOR_OTHER_REPORTS]: GetImprestStateList(
      filters[IMPREST_STATES],
      ALL_IMPREST_STATES_ARRAY
    )
  };
};
